const getExternalUrl = context => {
  switch (context) {
    case 'pellets':
      return 'https://enplus-pellets.de';
    case 'hackschnitzel':
      return 'https://enplus-hackschnitzel.de';
    case 'holzbriketts':
      return 'https://enplus-holzbriketts.de';
    case 'depi':
      return 'https://depi.de';
    case 'depv':
      return 'https://depv.de';
    default:
      return '/';
  }
};

export default getExternalUrl;
